@for(subcatCardConfigs of cardConfigsBySubcat; track $index) {
<div class="card-grid">
  @for(cardConfig of subcatCardConfigs; track cardConfig.title +
  cardConfig.transitionId) {
  <app-card
    [config]="cardConfig"
    [style.view-transition-name]="cardConfig.transitionId"
  ></app-card>
  }
</div>
}
